<template>
  <b-alert :show="isVisible" fade @dismissed="isVisible = false"  dismissible variant="success" role="alert">
    Novo Produto: {{ productData.description }} - #{{ productData.base_sku_id }}
  </b-alert>
</template>

<script>
export default {
  
  data: () => ({
    isVisible: false,
  }),

  watch: {
    product: {
      deep: true,

      handler(val) {
        if (this.product) {
          this.isVisible = true;
        } else {
          this.isVisible = false;
        }
      },
    },
  },

  computed: {

    product() {
      return this.$store.state.products.newProduct
    },

    productData() {
      if (this.product) {
        return this.product
      } 

      return {}
    },
  },
};
</script>

<style>
</style>